<template>
    <div 
        class="media--content--item"
        v-click-outside="editingMode"
    > 
     <portal to="training-item-gallery">
      <GallerySide
        v-if="galleryOpen"
        @returnPickedGif="galleryItemSelect"
        @closeGallery="galleryOpen = false"
      />
     </portal>
    <portal to="video-test-delete-modal">
      <GlobalModal
                  :modalInfo="{
                      text: 'test.are_you_sure',
                      confirmBtnText: 'delete_modal.yes_delete',
                      type: 'multiChoice',
                      multiChoiceYes: 'generic.yes',
                      multiChoiceNo: 'generic.no'
                  }"
                  @onChoiceOne="deleteWholeTest()"
                  @onChoiceTwo="isDeleteModalOpened=false"
                  @onClose="isDeleteModalOpened=false"
                  v-if="isDeleteModalOpened"
      />
      <GlobalModal
                  :modalInfo="{
                    text: 'video.keep_test',
                    undertext: 'video.test_transferred',
                    type: 'multiChoice',
                    multiChoiceYes: 'generic.yes',
                    multiChoiceNo: 'generic.no'
                  }"
                  @onChoiceOne="continueMediaChange"
                  @onChoiceTwo="continueMediaChange(true)"
                  @onClose="cancelMediaChange"
                  v-if="isVideoChangeModalOpened"/>
      <GlobalModal
                  :modalInfo="{
                    text: 'video.change_media',
                    undertext: 'video.test_deleted',
                    type: 'multiChoice',
                    multiChoiceYes: 'generic.yes',
                    multiChoiceNo: 'generic.no'
                  }"
                  @onChoiceOne="continueMediaChange(true)"
                  @onChoiceTwo="cancelMediaChange"
                  @onClose="cancelMediaChange"
                  v-if="isMediaChangeModalOpened"
      />
    </portal>
    <portal to="vtest-results-container">
      <GlobalModal
                :modalInfo="{
                  text: 'modal.user_scored',
                  bigUnderText: intScoredPercentage + '%',
                  confirmBtnText: 'save_modal.ok',
                  type: 'confirmation'
                }"
                @onConfirm="isResultsModalOpen = false"
                @onClose="isResultsModalOpen = false"
                v-if="isResultsModalOpen"
    />
    </portal>
    <transition name="expand">
        <div class="content--settings--container" v-if="!readOnly" v-show="!(!isEditing && item.content != '')">
          <div class="content--tabs">
            <div class="single--tab" :class="{active: currentMediaTab == 0}" @click="setMediaTab(0)">
              <span>{{item.type == 'doc' ? toLocal('media.document_upload') : toLocal('media.upload')}}</span>
            </div>
            <div v-if="(checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt')" class="single--tab" :class="{active: currentMediaTab == 1}" @click="setMediaTab(1)">
              <span>{{toLocal('media.video_settings')}}</span>
            </div>
            <div v-if="(checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt')" class="single--tab" :class="{active: currentMediaTab == 2}" @click="setMediaTab(2)">
              <span>{{toLocal('training.test_in_video')}}</span>
            </div>
            <div v-if="checkFileType(item.content) == 'doc'" class="single--tab" :class="{active: currentMediaTab == 1}" @click="setMediaTab(1)">
              <span>{{toLocal('media.doc_settings')}}</span>
            </div>
            <div v-if="['img', 'gif'].includes(checkFileType(item.content))" class="single--tab" :class="{active: currentMediaTab == 1}" @click="setMediaTab(1)">
              <span>{{toLocal('media.photo_settings')}}</span>
            </div>
            <div v-if="checkFileType(item.content) == 'audio'" class="single--tab" :class="{active: currentMediaTab == 1}" @click="setMediaTab(1)">
              <span>{{toLocal('media.rec_settings')}}</span>
            </div>
             <div v-if="item.type == 'scorm'" class="single--tab" :class="{active: currentMediaTab == 1}" @click="setMediaTab(1)">
              <span>{{toLocal('media.doc_settings')}}</span>
            </div>
          </div>
          <div class="media--settings" v-if="currentMediaTab==0">
            <div
              class="internet--editing"
              v-if="item.type != 'scorm'"
            >
              <div class="task--header">
                <div class="content-render-options" >
                  <span>{{toLocal('trainingItem.display_as_button')}}:</span>
                  <div class="btn-choice-container">
                    <div class="btn" :class="{'active':item.button}" @click="toggleItemButton(true)">{{toLocal('training_edit.answer_yes')}}</div>
                    <div class="btn" :class="{'active':!item.button}" @click="toggleItemButton(false)">{{toLocal('training_edit.answer_no')}}</div>
                  </div>
                </div>
              </div>
              <div 
                @click="!item.editing ? editWritingItem(topic, index) : ''"
                class="writing--task--content" 
              >

              </div>
                <div class="seperator">

                </div>
            </div>
            <div 
              class="item-content-container"
              :class="{'dragging-over': isDraggingOver}"
              @dragstart.prevent="uploadDragStart"
              @dragover.prevent="uploadDragOver"
              @dragleave.prevent="isDraggingOver=false"
              @dragdrop.prevent
              
            >
              <transition name="fade">
                <div class="upload-zone" @drop.prevent="onTrainingMediaChange($event, topic, index)" @dragover.prevent="uploadDragOverImage" v-show="isDraggingOver" @dragleave.prevent="isDraggingOver=false" >
                    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44C0 68.3005 19.6995 88 44 88Z" fill="#C5C5C5"/>
                      <path d="M86.3109 55.7101C82.2709 70.3601 70.8609 81.9401 56.3109 86.2101C55.8009 85.7701 55.3309 85.3101 54.9109 84.7801C54.2809 84.2901 53.7109 83.7201 53.2209 83.0901C52.5909 82.6001 52.0209 82.0301 51.5309 81.4001C50.8909 80.9101 50.3309 80.3301 49.8309 79.7001C49.2009 79.2101 48.6309 78.6401 48.1409 78.0101C47.5109 77.5201 46.9409 76.9501 46.4509 76.3201C45.8209 75.8301 45.2509 75.2601 44.7509 74.6301C44.1209 74.1401 43.5509 73.5701 43.0609 72.9401C42.4309 72.4501 41.8609 71.8801 41.3609 71.2501C40.7309 70.7601 40.1609 70.1901 39.6709 69.5501C39.0409 69.0601 38.4709 68.4901 37.9809 67.8601C37.3509 67.3601 36.7809 66.7901 36.2909 66.1601C35.6609 65.6701 35.0909 65.1001 34.5909 64.4701C33.9609 63.9801 33.4009 63.4101 32.9009 62.7801C32.2709 62.2901 31.7009 61.7101 31.2009 61.0901C30.5709 60.6001 30.0009 60.0201 29.5109 59.3901C28.8809 58.9001 28.3109 58.3301 27.8209 57.7001C27.1909 57.2001 26.6209 56.6301 26.1309 56.0001C25.5009 55.5101 24.9309 54.9401 24.4409 54.3101C23.8109 53.8201 23.2409 53.2501 22.7509 52.6201C20.4409 50.8201 18.9609 48.0101 18.9609 44.8601C18.9609 39.5801 23.1409 35.2501 28.3709 35.0201C28.5409 35.0201 28.7009 35.0101 28.8709 35.0101H28.9109C29.0009 35.0101 29.1009 35.0101 29.1909 35.0101C29.3209 35.0101 29.4609 35.0301 29.6009 35.0401C29.6009 35.0401 29.6609 35.0401 29.7009 35.0401C30.3109 28.6301 35.5509 23.6401 41.9709 23.3401C42.1609 23.3401 42.3509 23.3301 42.5409 23.3301H42.5909C46.0809 23.3601 49.2809 25.0101 51.6009 27.7801C51.7209 27.8801 51.8409 27.9901 51.9609 28.1001C52.8509 29.2401 53.6009 30.5501 54.1609 32.0201C54.3209 31.9701 54.4809 31.9201 54.6509 31.8601C55.4809 31.6001 56.4109 31.2901 57.1709 31.2801H57.1909C57.2909 31.2801 57.3909 31.2801 57.4809 31.2801C60.9909 31.4001 64.1009 33.0601 66.1709 35.6001C66.2809 35.6901 66.3909 35.7801 66.4909 35.8701C66.9909 36.3001 67.4509 36.7801 67.8609 37.2901C68.4809 37.8001 69.0509 38.3701 69.5609 38.9901C70.1809 39.4901 70.7509 40.0601 71.2509 40.6801C71.8709 41.1801 72.4309 41.7501 72.9409 42.3701C73.5609 42.8701 74.1309 43.4401 74.6309 44.0601C75.2509 44.5601 75.8209 45.1301 76.3209 45.7501C76.9409 46.2601 77.5109 46.8301 78.0209 47.4401C78.6409 47.9501 79.2009 48.5201 79.7109 49.1301C80.3309 49.6401 80.9009 50.2101 81.4109 50.8301C82.0309 51.3301 82.5909 51.9001 83.1009 52.5201C83.7209 53.0201 84.2909 53.5901 84.7909 54.2101C85.3409 54.6501 85.8309 55.1501 86.2909 55.6901L86.3109 55.7101Z" fill="#ACACAC"/>
                      <path d="M57.2105 31.2898C56.4405 31.2898 55.5005 31.5998 54.6605 31.8698C54.4905 31.9298 54.3305 31.9798 54.1705 32.0298C52.1305 26.7398 47.6405 23.3398 42.6005 23.3398C35.9005 23.3398 30.3305 28.4498 29.7105 35.0598C29.4305 35.0398 29.1705 35.0198 28.9205 35.0198C23.4805 35.0198 19.0605 39.4398 19.0605 44.8798C19.0605 50.3198 23.4805 54.7398 28.9205 54.7398H57.6105V54.7198C63.8906 54.4998 68.9305 49.3398 68.9305 43.0198C68.9305 36.6998 63.6705 31.2998 57.2005 31.2998L57.2105 31.2898Z" fill="white"/>
                      <path d="M54.23 47.6296C54.18 47.5196 54.11 47.4096 54.03 47.3096L46.85 37.7696C46.76 37.6396 45.77 36.3096 44.12 36.3096C43.4 36.3096 42.34 36.5696 41.39 37.7996L34.42 47.4896C34.29 47.6696 34.19 47.8696 34.13 48.0796C33.75 49.3696 34.2 50.2396 34.5 50.6396C35.25 51.6396 36.4 51.7196 36.74 51.7196H39.32V62.6996C39.32 63.7796 40.21 64.6596 41.29 64.6596H47.35C48.43 64.6596 49.25 63.7796 49.25 62.6996V51.7196H51.7C52.1 51.7196 53.47 51.6296 54.21 50.4496C54.5 49.9796 54.89 48.9896 54.23 47.6296Z" fill="#ACACAC"/>
                    <path d="M36.01 48.6299L42.94 38.9899C44.18 37.3899 45.28 38.9399 45.28 38.9399L52.46 48.4899C53.1 49.8099 51.69 49.7699 51.69 49.7699H47.28V61.9599C47.28 62.3699 46.95 62.7099 46.53 62.7099H42.01C41.6 62.7099 41.26 62.3799 41.26 61.9599V49.7699H36.73C36.73 49.7699 35.65 49.7899 35.99 48.6299H36.01Z" fill="white"/>
                    </svg>
                </div>
              </transition>
              <div class="label">
                {{toLocal('training_edit.drag_media')}}
              </div>
              <ItemUploadOptions
                v-if="item && item.type != 'url'"
                :item="item"
                :item_index="index ? index : 0"
                :topic_index="topic ? topic : 0"
                :trainingType="trainingType"
                @openGallery="openGallery(topic, index)"
                @onTrainingMediaChange="onTrainingMediaChange"
              />
              <!-- <div class="frame-container" v-if="item.type != 'url'">
                <div 
                  :class="['media--editing','full--editing narrow--editing', (item.content != '' ? 'has-content' : ''), (item.uploading ? 'uploading' : '')]"
                  v-show="mobileUploadModal[0] == -1 && audioRecordModal[0] == -1"
                >
                  <div :class="['uploading', (item.uploading ? 'active': '')]">
                    <div 
                      class="upload--progress"
                      :style="[{'width': `${$store.state.uploadedData / item.file_size * 100}%`}]" 
                    ></div>
                      <div 
                      class="upload--progress--label"
                      :style="{'left': `max(0px, ${$store.state.uploadedData / item.file_size * 100}% - 52px)`}"
                    >
                          <span>{{($store.state.uploadedData / item.file_size * 100).toFixed(0)}} %</span>
                          {{toLocal('training.file_being_uploaded')}}
                      </div>
                  </div>
                  <input 
                    :ref="`trainingItemFile-${topic}-${index}`" 
                    accept=".mp4,.mov,.mp3,.pdf,.pptx,.xlsx,.docx,.ppt,.xls,.doc,.png,.jpg,.jpeg,.m4a,.wav,.aac,.3gp,.amr,.odp,.ods,.odt,.webm,.gif,.bmp,.heic,.heif,.zip"
                    type="file"
                    style="display: none;"
                    @change="onTrainingMediaChange($event, topic, index); item.contentType = ''; item.url =''"
                  >
                    <div class="media--action" v-if="item.type == 'video'">
                    <img 
                      src="../../assets/images/icons/training-item-audio-record.svg"
                      @click="audioRecordModal = [topic, index]"
                    >
                    <div class="description" :class="{'shown': item.content == ''}">
                      {{toLocal('training_edit.upload_options.audio')}}
                    </div>
                  </div>
                  <div class="media--action">
                    <img 
                      src="../../assets/images/icons/training-item-mobile-upload.svg"
                      @click="mobileUploadModal = [topic, index]; generateQRCode(topic, index)"
                    >
                    <div class="description" :class="{'shown': item.content == ''}">
                      {{toLocal('training_edit.upload_options.mobile')}}
                    </div>
                  </div>
                  <div class="media--action">
                    <img 
                      src="../../assets/images/icons/training-item-upload.svg"
                      @click="$refs[`trainingItemFile-${topic}-${index}`].click()" 
                    >
                    <div class="description" :class="{'shown': item.content == ''}">
                      {{toLocal('training_edit.upload_options.computer')}}
                    </div>
                  </div>
                  <div class="media--action" >
                    <img 
                      src="../../assets/images/icons/training-item-gallery.svg"
                      @click="openGallery(topic, index)"
                    >
                    <div class="description" :class="{'shown': item.content == ''}">
                      {{toLocal('training_edit.upload_options.elklase_gallery')}}
                    </div>
                  </div>
                
            
                </div>
                  <div class="QR-code-modal-container" v-show="mobileUploadModal[0] != -1">
                    <div class="QR-code-modal">
                      <div class="QR-code-modal-close" @click="mobileUploadModal = [-1, -1]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                            <g id="Group_6902" data-name="Group 6902" transform="translate(-1283 -278)">
                                <g id="Ellipse_493" data-name="Ellipse 493" transform="translate(1283 278)" fill="none" stroke="#28345c" stroke-width="1">
                                <circle cx="21" cy="21" r="21" stroke="none"/>
                                <circle cx="21" cy="21" r="20.5" fill="none"/>
                                </g>
                                <g id="Group_5546" data-name="Group 5546" transform="translate(1304.003 283.224) rotate(45)">
                                <g id="Path_749" data-name="Path 749">
                                    <path id="Path_751" data-name="Path 751" d="M200.6,57.828a1.2,1.2,0,0,1-.355.853,1.176,1.176,0,0,1-.853.363h-8.728v8.728a1.226,1.226,0,0,1-1.217,1.208,1.2,1.2,0,0,1-.853-.355,1.176,1.176,0,0,1-.363-.853V59.044h-8.728a1.219,1.219,0,0,1-.862-2.07,1.267,1.267,0,0,1,.862-.363h8.728v-8.72a1.186,1.186,0,0,1,.363-.87,1.2,1.2,0,0,1,.853-.355,1.23,1.23,0,0,1,1.217,1.225v8.72H199.4A1.232,1.232,0,0,1,200.6,57.828Z" transform="translate(-178.297 -46.666)" fill="#28345c"/>
                                </g>
                                </g>
                            </g>
                        </svg>
                      </div>
                        <qrcode-vue :key="item.QRLink" :value="item.QRLink ? item.QRLink : ''" :size="200" level="H" />
                    </div>
                  </div>
                  <div class="audio-record-modal-container" v-show="audioRecordModal[0] != -1">
                    <div class="audio-record-modal">
                      <div class="audio-modal-close" @click="audioRecordModal = [-1, -1]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                            <g id="Group_6902" data-name="Group 6902" transform="translate(-1283 -278)">
                                <g id="Ellipse_493" data-name="Ellipse 493" transform="translate(1283 278)" fill="none" stroke="#28345c" stroke-width="1">
                                <circle cx="21" cy="21" r="21" stroke="none"/>
                                <circle cx="21" cy="21" r="20.5" fill="none"/>
                                </g>
                                <g id="Group_5546" data-name="Group 5546" transform="translate(1304.003 283.224) rotate(45)">
                                <g id="Path_749" data-name="Path 749">
                                    <path id="Path_751" data-name="Path 751" d="M200.6,57.828a1.2,1.2,0,0,1-.355.853,1.176,1.176,0,0,1-.853.363h-8.728v8.728a1.226,1.226,0,0,1-1.217,1.208,1.2,1.2,0,0,1-.853-.355,1.176,1.176,0,0,1-.363-.853V59.044h-8.728a1.219,1.219,0,0,1-.862-2.07,1.267,1.267,0,0,1,.862-.363h8.728v-8.72a1.186,1.186,0,0,1,.363-.87,1.2,1.2,0,0,1,.853-.355,1.23,1.23,0,0,1,1.217,1.225v8.72H199.4A1.232,1.232,0,0,1,200.6,57.828Z" transform="translate(-178.297 -46.666)" fill="#28345c"/>
                                </g>
                                </g>
                            </g>
                        </svg>
                      </div>
                      <AudioRecord v-if="audioRecordModal[0] != -1" @fileBlob="onTrainingMediaChange($event, topic, index)" @closeModal="audioRecordModal = [-1, -1]"> </AudioRecord>
                    </div>
                  </div>
              </div> -->
              <div class="url-container" v-if="item.type != 'scorm'">
                <div class="url-label">
                  {{toLocal('training_edit.add_link')}}
                </div>
                <div class="url-input">
                  <input 
                    type="text" 
                    :value="item.url"
                    :ref="`trainingURLInput-${topic}-${index}`"
                    @blur="loadContent($event)"
                    @keyup.enter="$event.target.blur()"
                    @mouseover="toggleDrag(true)"
                    @mouseleave="toggleDrag(false)"
                    >
                </div>
                <div class="button-title" v-if="item.button">
                  <div class="url-label">
                    {{toLocal('training_edit.add_button_name')}}
                  </div>
                  <div class="url-input">
                    <input 
                      type="text"
                      v-model="item.title"
                      @mouseover="toggleDrag(true)"
                      @mouseleave="toggleDrag(false)"
                      >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="video--settings" v-if="currentMediaTab==1 && (checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt')">
            <div class="left-half">
              <div class="setting">
                <span class="setting-title">{{toLocal('video.video_start')}}:</span>
                <div class="timestamp-container">
                  <input type="number" @input="updateVideoStartTime = !updateVideoStartTime" v-model="startTime.h" max="24" min="0"/>
                  <span>{{toLocal('generic.hours_short')}}</span>
                  <input type="number" @input="updateVideoStartTime = !updateVideoStartTime" v-model="startTime.m" max="60" min="0"/>
                  <span>{{toLocal('generic.min')}}</span>
                  <input type="number" @input="updateVideoStartTime = !updateVideoStartTime" v-model="startTime.s" max="60" min="0"/>
                  <span>{{toLocal('generic.sec_short')}}</span>
                  <VTooltip  :triggers="['hover']" :placement="'top'">
                    <div class="arrow-right arrow" @click="insertTime('front')">
                      <VideoTimeArrowSvg/>
                    </div>
                    <template #popper>
                      {{toLocal('video.set_current_start')}}
                    </template>
                  </VTooltip>
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.video_end')}}:</span>
                <div class="timestamp-container">
                  <input type="number" @input="setEndInput" v-model="endTime.h" max="24" min="0"/>
                  <span>{{toLocal('generic.hours_short')}}</span>
                  <input type="number" @input="setEndInput" v-model="endTime.m" max="60" min="0"/>
                  <span>{{toLocal('generic.min')}}</span>
                  <input type="number" @input="setEndInput" v-model="endTime.s" max="60" min="0"/>
                  <span>{{toLocal('generic.sec_short')}}</span>
                  <VTooltip   :triggers="['hover']" :placement="'top'">
                    <div class="arrow-left arrow" @click="insertTime('end')">
                    <VideoTimeArrowSvg/>
                  </div>
                    <template #popper>
                      {{toLocal('video.set_current_end')}}
                    </template>
                  </VTooltip>
                </div>
              </div>
            </div>
            <div class="right-half">
              <div class="setting">
                <span class="setting-title">{{toLocal('video.allow_seek')}}:</span>
                <div class="input-box btns-only">
                  <div class="i-btn" :class="{active: allowSeek == true}" @click="changeSetting('seek', true)">{{toLocal('training_edit.answer_yes')}}</div>
                  <div class="i-btn" :class="{active: allowSeek == false}" @click="changeSetting('seek', false)">{{toLocal('training_edit.answer_no')}}</div>
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.allow_continue')}}:</span>
                <div class="input-box btns-only">
                  <div class="i-btn" :class="{active: allowContinue == true}" @click="changeSetting('continue', true)">{{toLocal('training_edit.answer_yes')}}</div>
                  <div class="i-btn" :class="{active: allowContinue == false}" @click="changeSetting('continue', false)">{{toLocal('training_edit.answer_no')}}</div>
                </div>
              
              </div>
              <div class="setting" v-if="checkFileType(item.content) == 'video'">
                <span class="setting-title">{{toLocal('video.upload_subtitles')}}:</span>
                <div class="input-box btns-only center">
                  <input type="file" ref="subUploadBtn" class="sub_upload_btn" accept=".srt, .vtt" @change="uploadSubFile($event, topic, index)"/>
                  <div class="i-btn" @click="uploadSubtitles()">{{toLocal('generic.upload')}}</div>
                </div>
              </div>
            </div>
          </div>
            <div 
              class="scorm--settings" 
              v-if="currentMediaTab==1 && item.type == 'scorm'"  
              @mouseover="toggleDrag(true)"
              @mouseleave="toggleDrag(false)"
            >
            <div class="setting-col border--bottom top-row">
              <div class="setting-row mb-8">
                <span class="left-col">
                  {{toLocal('scorm.package_title')}}
                </span>
                <span>
                  {{item.data ? item.data.title : '-'}}
                </span>
              </div>
              <div class="setting-row">
                <span class="left-col">
                 {{toLocal('scorm.format')}}
                </span>
                <span>
                  {{item.data && item.data.format ? toLocal('scorm.format_'+item.data.format) : '-'}}
                </span>
              </div>
            </div>
            <div class="setting-row bottom-col gap-45">
              <div class="setting-col">
                <div class="setting-row btn-row mb-8">
                  {{toLocal('training_item.show_separate_window')}}:
                </div>
                <div class="setting-row btn-row">
                  <button class="i-btn" @click="$set(item.options,'popup',true)" :class="{active: item.options && item.options.popup}">
                    {{toLocal('training_edit.answer_yes')}}
                  </button>
                  <button class="i-btn" @click="$set(item.options,'popup',false)" :class="{active: item.options && !item.options.popup}">
                    {{toLocal('training_edit.answer_no')}}
                  </button>
                </div>
              </div>
              <div class="setting-col">
                <div class="setting-row btn-row mb-8">
                  {{toLocal('training_item.allow_repeated_view')}}:
                </div>
                <div class="setting-row btn-row">
                   <button class="i-btn" @click="$set(item.options,'allowRetry',true)" :class="{active: item.options && item.options.allowRetry}">
                    {{toLocal('training_edit.answer_yes')}}
                  </button>
                  <button class="i-btn" @click="$set(item.options,'allowRetry',false)" :class="{active: item.options && !item.options.allowRetry}">
                    {{toLocal('training_edit.answer_no')}}
                  </button>
                </div>
              </div>
              <div class="setting-col">
                <div class="setting-row btn-row mb-8">
                  {{toLocal('scorm.options_continue_without_completing')}}:
                </div>
                <div class="setting-row btn-row">
                  <button class="i-btn" @click="$set(item.options,'continueAfterTry',false)" :class="{active: item.options && !item.options.continueAfterTry}">
                    {{toLocal('training_edit.answer_yes')}}
                  </button>
                  <button class="i-btn" @click="$set(item.options,'continueAfterTry',true)" :class="{active: item.options && item.options.continueAfterTry}">
                    {{toLocal('training_edit.answer_no')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="vtest--settings" v-if="currentMediaTab==2 && (checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt')">
            <div class="settings-inner">
              <div class="setting">
                <span class="setting-title">{{toLocal('video.test_passed_from')}}:</span>
                <div class="input-box">
                  <input type="number" class="active" max="100" min="0" v-model="objTestOptions.passed_from"/>%
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.solve_count')}}:</span>
                <div class="input-box">
                  <input type="number" @input="objTestOptions.unlimited_retakes = false" :class="{active: !objTestOptions.unlimited_retakes}" min="0" v-model="objTestOptions.retake_test"/><span>{{toLocal('video.times_or')}} </span>
                  <div class="i-btn again" @click="objTestOptions.unlimited_retakes = !objTestOptions.unlimited_retakes" :class="{active: objTestOptions.unlimited_retakes == true}">{{toLocal('video.unlimited_solves')}}</div>
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.solve_time')}}:</span>
                <div class="input-box">
                  <input type="number" class="active" min="0" max="60" v-model="objTestOptions.test_shown_duration"/><span>{{toLocal('generic.sec_short')}}</span>
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.partially_correct')}}:</span>
                <div class="input-box btns-only">
                  <div class="i-btn" @click="objTestOptions.partially_correct = true" :class="{active: objTestOptions.partially_correct}">{{toLocal('training_edit.answer_yes')}}</div>
                  <div class="i-btn" @click="objTestOptions.partially_correct = false" :class="{active: !objTestOptions.partially_correct}">{{toLocal('training_edit.answer_no')}}</div>
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.show_answer')}}:</span>
                <div class="input-box btns-only">
                  <div class="i-btn" @click="objTestOptions.show_answers = true" :class="{active: objTestOptions.show_answers}">{{toLocal('training_edit.answer_yes')}}</div>
                  <div class="i-btn" @click="objTestOptions.show_answers = false" :class="{active: !objTestOptions.show_answers}">{{toLocal('training_edit.answer_no')}}</div>
                </div>
              </div>
              <div class="setting">
                <span class="setting-title">{{toLocal('video.show_results')}}:</span>
                <div class="input-box btns-only">
                  <div class="i-btn" @click="objTestOptions.show_results = true" :class="{active: objTestOptions.show_results}">{{toLocal('training_edit.answer_yes')}}</div>
                  <div class="i-btn" @click="objTestOptions.show_results = false" :class="{active: !objTestOptions.show_results}">{{toLocal('training_edit.answer_no')}}</div>
                </div>
              </div>
            </div>
            <div class="video-test-btn"  v-if="(checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt')" >
              <button @click="toggleVideoTest" v-if="!isVideoTestOpen" class="new-question-btn">{{ toLocal('test.add_question') }} <AssignPlusSvg width="20px" height="20px"/></button>
              <div class="desc-open" v-if="isVideoTestOpen">
                <span class="delete-whole" @click="deleteTestModal()">{{toLocal('test.delete_test')}}</span>
              </div>
            </div>
            <div 
              class="video-test"
              :key="item.content"
              v-if="(checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt') && isVideoTestOpen"
            >
                  <div class="already-existing" v-if="currentVideoTests && currentVideoTests.length != 0 && currentVideoTests[currentQuestion]">
                    <VideoTest
                    :key="currentVideoTests[currentQuestion].id"
                    :currentTest="currentVideoTests[currentQuestion]" 
                    :readOnly="readOnly" 
                    :number="currentQuestion+1" 
                    :videoDuration="videoDuration" 
                    :trainingId="$store.state.currentTraining" 
                    :videoId="item.id"
                    @deleteQuestion="deleteQuestion"
                    @toggleDrag="toggleDrag($event)"
                    />
                  </div>
                  <VideoTest 
                    v-else 
                    :videoDuration="videoDuration" 
                    :trainingId="$store.state.currentTraining" 
                    number="1" 
                    :videoId="item.id"
                    @deleteQuestion="deleteQuestion"
                    @toggleDrag="toggleDrag($event)"
                  /> 
                  <div class="video-test-under">
                    <button @click="addNewQuestion" class="new-question-btn">{{ toLocal('test.add_question') }} <AssignPlusSvg width="20px" height="20px"/></button>
                    <div class="video-nav" v-if="currentVideoTests.length > 1">
                      <div class="nav nav-back" :class="{inactive: currentQuestion == 0}" @click="changeQuestion(currentQuestion-1)">
                        <span>&lt; {{toLocal('generic.question')}} <span v-if="currentQuestion != 0">{{ currentQuestion}}</span></span>
                      </div>
                      <div class="nav-middle">
                        <span>{{ currentQuestion+1 }}</span>
                      </div>
                      <div class="nav nav-ahead" :class="{inactive: currentVideoTests[currentQuestion+1] == undefined}" @click="changeQuestion(currentQuestion+1)">
                        {{toLocal('generic.question')}} {{ currentQuestion+2 }} >
                      </div>

                    </div>
                  </div>
            </div>
          </div>
          <!-- <div class="img--settings" v-if="currentMediaTab==1 && ['img', 'gif'].includes(checkFileType(item.content)) ">

          </div> -->
          <div class="doc--settings" v-if="currentMediaTab==1 && checkFileType(item.content) == 'doc'">
            <div class="content-render-options">
                    <span>{{toLocal('training_item.allow_download')}}:</span>

                  <div class="btn-choice-container">
                    <div class="btn" :class="{'active':item.downloadable}" @click="item.downloadable = true;$forceUpdate()">{{toLocal('training_edit.answer_yes')}}</div>
                    <div class="btn" :class="{'active':!item.downloadable}" @click="item.downloadable = false;$forceUpdate()">{{toLocal('training_edit.answer_no')}}</div>
                  </div>
            </div>
          </div>
          </div>
        </transition>
        <div 
        v-if="!item.content=='' && !item.uploading" 
        class="embed relative-container" 
        v-show="!item.button"
        :class="{'editing': isEditing, 'half': item.half}"
        :style="{
          'padding-top': getEmbedAspectRatio(item),
          'height': item.embed_options != undefined && item.embed_options.height != undefined ? item.embed_options.height/item.embed_options.width < 1 && item.embed_options.height/item.embed_options.width > 0.4 ? '56.25%' : 'min(88vh, '+item.embed_options.height+'px)' : '56.25%',
          'width': item.embed_options != undefined && item.embed_options.width != undefined ? item.embed_options.height/item.embed_options.width < 1 && item.embed_options.height/item.embed_options.width > 0.4 ? '100%' : 'min('+item.embed_options.width+'px, 100%)' : ''
          }"
        >
            <VideoTest 
            v-if="(checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt') && readOnly && isVideoTestOpen"
            :key="item.id"
            :currentTest="playingVideoTest" 
            :readOnly="readOnly" 
            @continueVideo="continueVideo"
            :videoSettings="objTestOptions"
            />
            <VideoPlayer
              v-if="checkFileType(item.content) == 'video' && isNativeVideo(item) && item.content != ''"
              :key="updateKey"
              :options="{
                autoplay: false,
                controls: true,
                controlBar:{
                  pictureInPictureToggle: false,
                },
                playbackRates: [0.5, 1, 1.5, 2],
                preload: 'metadata',
                type: 'upload',
                videoTests: currentVideoTests,
                currentTest: playingVideoTest,
                readOnly: readOnly,
                isVideoSettingsOpen:currentMediaTab == 1 && checkFileType(item.content) == 'video',
                allowSeeking: trainingItem.allow_seek != undefined ? trainingItem.allow_seek : true,
                start_time: trainingItem.start_time,
                plugins:{
                  offset: {
                    restart_beginning: true,
                    start: readOnly && trainingItem.start_time ? trainingItem.start_time : isEditing ? 0 : trainingItem.start_time,
                    end: readOnly && trainingItem.end_time ? trainingItem.end_time : isEditing ? null : trainingItem.end_time,
                  }
                },
                sources: [
                  {
                    src:
                      getTrainingFileURL(item.content),
                      
                  }
                ]
              }"
              :src="getTrainingFileURL(item.content)"
              ref="videoLazy"
              @loaded="lazyload"
              @loadedmetadata="getDuration"
            />

            <VideoRangeSlider
            :startTime ="startTime"
            :endTime="endTime"
            :videoPlay="videoPlay"
            :updateVideoStartTime = "updateVideoStartTime"
            :updateVideoEndTime = "updateVideoEndTime"
            :countVideoTime = "countVideoTime"
            :isAnyVideoTests = "videoTests"
             v-if="(checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt') && isEditing && currentMediaTab==1 && !readOnly"/>
              <VideoPlayer
              v-if="checkFileType(item.content) == 'yt'"
              :options="{
                autoplay: false,
                controls: true,
                controlBar:{
                  pictureInPictureToggle: false,
                },
                item_id: training.id+'_'+item.id,
                preload: 'metadata',
                videoTests: currentVideoTests,
                currentTest: playingVideoTest,
                readOnly:readOnly,
                preferFullWindow: true,
                playbackRates: [0.5, 1, 1.5, 2],
                techOrder:['youtube'],
                type: 'yt',
                youtube:{
                  cc_load_policy: 1,
                  enablejsapi: 1,
                  modestBranding:1,
                  showinfo:0},
                isVideoSettingsOpen:currentMediaTab == 1 && checkFileType(item.content) == 'yt',
                ytVideoOnTabOne: currentMediaTab == 0 && checkFileType(item.content) == 'yt',
                allowSeeking: trainingItem.allow_seek != undefined ? trainingItem.allow_seek : true,
                start_time: trainingItem.start_time,
                plugins:{
                  offset: {
                    start: readOnly && trainingItem.start_time != undefined ? trainingItem.start_time : 0,
                    end: readOnly && trainingItem.end_time != undefined ? trainingItem.end_time : null,
                  },
                },
                sources: [
                  {
                    src: item.content,
                    type: 'video/youtube'
                  }
                ]
              }"
              ref="videoLazyYoutube"
              @loaded="lazyload"
              @loadedmetadata="getDuration"
              />
              <!-- <iframe
                  v-if="readOnly && checkFileType(item.content) == 'yt' && isIOS()"
                  style="border:none;overflow:hidden"
                  allowfullscreen="true"
                  autoplay="0"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  :key="item.content"
                  :class="[(item.embed_options ? item.embed_options.height/item.embed_options.width *100 >=57 ? 'has-options': '' : '')]"
                  :height="item.embed_options ? item.embed_options.height : ''"
                  :width="item.embed_options ? item.embed_options.width : ''"
                  :src="item.content+(readOnly && trainingItem.start_time != undefined ? '&start='+trainingItem.start_time : '')+(readOnly && trainingItem.end_time != undefined ? '&end='+trainingItem.end_time : '')"
              /> -->


            <lazy-component :key="item.content" @show="lazyload" tag="div" v-if="checkFileType(item.content) == false && item.content != '' && item.contentType == 'frame'">
              <iframe
                  style="border:none;overflow:hidden"
                  allowfullscreen="true"
                  autoplay="0"
                  loading="lazy"
                  :key="item.content"
                  :class="[(item.embed_options ? item.embed_options.height/item.embed_options.width *100 >=57 ? 'has-options': '' : '')]"
                  :height="item.embed_options ? item.embed_options.height : ''"
                  :width="item.embed_options ? item.embed_options.width : ''"
                  v-if="checkFileType(item.content) == false && item.content != '' && item.contentType == 'frame'"
                  :src="getTrainingFileURL(item.content)"
                  @load="loadedFrame"
              />
            </lazy-component>
            <lazy-component :key="item.content" @show="lazyload" tag="div" v-if="checkFileType(item.content) == 'doc' && item.content != ''">
              <iframe
                  class="documents"
                  style="border:none;overflow:hidden;"
                  autoplay="0"
                  allowfullscreen="true"
                  loading="lazy"
                  :key="item.content"
                  :class="[
                    (item.embed_options ? item.embed_options.height/item.embed_options.width *100 >=57 ? 'has-options': '' : ''),
                    (item.embed_options ? item.embed_options.height/item.embed_options.width >=1 ? 'vertical' : '' : '')
                    ]"
                  :height="item.embed_options ? item.embed_options.height : ''"
                  :width="item.embed_options ? item.embed_options.width : ''"
                  v-if="checkFileType(item.content) == 'doc' && item.content != ''"
                  :src="getPreviewDocumentUrl(item.content)"
                  @load="loadedFrame"
              />
            </lazy-component>
            <div v-show="item.downloadable && !item.button && checkFileType(item.content) == 'doc' && readOnly" class="url--button--container">
              <a class="url--button" :href="getTrainingFileURL(item.content)" target="_blank">{{toLocal('generic.download')}}</a>
            </div>
              <audio
                  v-if="checkFileType(item.content) == 'audio' && item.content!='' && !item.uploading"
                  :src="getTrainingFileURL(item.content)"
                  controls
              />
            <lazy-component :key="item.content" @show="lazyload" tag="div"  v-if="item.contentType == 'blockquote' && checkFileType(item.content) == false">
              <Embed 
                  :data="item.content" 
                  :script="item.script"
                  :key="item.content" 
                  v-if="item.contentType == 'blockquote' && checkFileType(item.content) == false" 
              />
            </lazy-component>
             <NewImageEditor 
              v-if="['img', 'gif'].includes(checkFileType(item.content)) "
              :readOnly="readOnly"
              :item="item"
              :key="item.content != null ? getTrainingFileURL(item.content) : ''"
              type="item"
              :isImageRounded="true"
              :isEditing="isEditing && currentMediaTab == 1"
              :half = "trainingItem.half"
              :editingState = "isEditing"
              :src="item.content != null ? getTrainingFileURL(item.content) : ''"
              @disableDrag="toggleDrag(true)"
              @enableDrag="toggleDrag(false)"
              
            />
            <ScormPlayer 
              v-if="item.type=='scorm'"
              :item="item"
              @toggleDrag="toggleDrag($event)"
              @scormStatus="$emit('scormStatus', $event)"
            />
           
            <!-- <div class="lazy-load" v-if="isLazyLoading && ['doc','video', false].includes(checkFileType(item.content)) && item.content != '' && !item.button && !item.downloadable">
            </div> -->
        
        </div>
        <div v-show="item.url != '' && item.button && item.title != ''" class="url--button--container" :class="{'extra-top-padding': item.button && readOnly && training.content && training.content[training.content.length-1] && training.content[training.content.length-1].type != 'seperator'}">
            <a class="url--button" :class="{edit: !readOnly}" :href="getTrainingFileURL(item.content)" target="_blank">{{item.title}}</a>
        </div>
        <div 
        :class="['media--editing', 'url--editing', {'video--elems': checkFileType(item.content) == 'video' || checkFileType(item.content) == 'yt'}]"
        v-if="!readOnly "
        >
          <div class="media--action" v-show="!isEditing && item.content != ''">
            <svg @click="isEditing=true; $emit('edit', isEditing)" class="fill" xmlns="http://www.w3.org/2000/svg" width="37.214" height="37.214" viewBox="0 0 37.214 37.214">
              <g id="Nustatymai" transform="translate(12 -0.001)">
                <g id="Group_50" data-name="Group 50" transform="translate(-12 0.001)">
                  <path id="Path_69" data-name="Path 69" d="M35.309,14.7,32.7,14.259a14.749,14.749,0,0,0-1.049-2.534l1.539-2.153a2.292,2.292,0,0,0-.249-2.962L30.622,4.292A2.282,2.282,0,0,0,29,3.616a2.259,2.259,0,0,0-1.329.428L25.506,5.583A14.6,14.6,0,0,0,22.879,4.5l-.435-2.581A2.3,2.3,0,0,0,20.174,0H16.9a2.3,2.3,0,0,0-2.27,1.92L14.18,4.564a14.386,14.386,0,0,0-2.527,1.065L9.515,4.09a2.3,2.3,0,0,0-2.962.249L4.229,6.656A2.3,2.3,0,0,0,3.98,9.617L5.535,11.8A14.406,14.406,0,0,0,4.5,14.344l-2.581.435A2.3,2.3,0,0,0,0,17.049v3.273a2.3,2.3,0,0,0,1.92,2.27l2.643.451A14.386,14.386,0,0,0,5.628,25.57L4.1,27.7a2.292,2.292,0,0,0,.249,2.962l2.317,2.317a2.282,2.282,0,0,0,1.625.676,2.259,2.259,0,0,0,1.329-.428L11.8,31.672a14.707,14.707,0,0,0,2.457,1.011l.435,2.612a2.3,2.3,0,0,0,2.27,1.92h3.281a2.3,2.3,0,0,0,2.27-1.92l.443-2.612a14.749,14.749,0,0,0,2.534-1.049l2.153,1.539a2.282,2.282,0,0,0,1.337.428h0a2.282,2.282,0,0,0,1.625-.676l2.317-2.317a2.3,2.3,0,0,0,.249-2.962l-1.539-2.161a14.643,14.643,0,0,0,1.049-2.534l2.612-.435a2.3,2.3,0,0,0,1.92-2.27V16.972A2.269,2.269,0,0,0,35.309,14.7Zm-.179,5.543a.2.2,0,0,1-.171.2l-3.265.544a1.044,1.044,0,0,0-.84.77A12.445,12.445,0,0,1,29.5,25.018a1.051,1.051,0,0,0,.047,1.143l1.92,2.705a.212.212,0,0,1-.023.264l-2.317,2.317a.2.2,0,0,1-.148.062.191.191,0,0,1-.117-.039l-2.7-1.92a1.05,1.05,0,0,0-1.143-.047,12.445,12.445,0,0,1-3.257,1.353,1.032,1.032,0,0,0-.77.84l-.552,3.265a.2.2,0,0,1-.2.171H16.971a.2.2,0,0,1-.2-.171L16.224,31.7a1.044,1.044,0,0,0-.77-.84,12.922,12.922,0,0,1-3.187-1.306,1.076,1.076,0,0,0-.529-.14,1.024,1.024,0,0,0-.606.194L8.411,31.54a.231.231,0,0,1-.117.039.208.208,0,0,1-.148-.062L5.83,29.2a.211.211,0,0,1-.023-.264L7.72,26.254A1.064,1.064,0,0,0,7.766,25.1,12.328,12.328,0,0,1,6.4,21.854a1.065,1.065,0,0,0-.84-.77l-3.288-.56a.2.2,0,0,1-.171-.2V17.049a.2.2,0,0,1,.171-.2L5.512,16.3a1.051,1.051,0,0,0,.847-.777,12.432,12.432,0,0,1,1.329-3.265,1.038,1.038,0,0,0-.054-1.135L5.7,8.4a.212.212,0,0,1,.023-.264L8.038,5.824a.2.2,0,0,1,.148-.062A.191.191,0,0,1,8.3,5.8l2.682,1.912a1.064,1.064,0,0,0,1.151.047,12.328,12.328,0,0,1,3.25-1.368,1.065,1.065,0,0,0,.77-.84l.56-3.288a.2.2,0,0,1,.2-.171h3.273a.2.2,0,0,1,.2.171L20.935,5.5a1.051,1.051,0,0,0,.777.847,12.618,12.618,0,0,1,3.335,1.368,1.051,1.051,0,0,0,1.143-.047l2.682-1.928a.231.231,0,0,1,.117-.039.208.208,0,0,1,.148.062l2.317,2.317a.211.211,0,0,1,.023.264l-1.92,2.7a1.05,1.05,0,0,0-.047,1.143,12.445,12.445,0,0,1,1.353,3.257,1.032,1.032,0,0,0,.84.77l3.265.552a.2.2,0,0,1,.171.2v3.273Z" transform="translate(0 -0.001)" fill="#707070"/>
                  <path id="Path_70" data-name="Path 70" d="M144.131,136a8.031,8.031,0,1,0,8.031,8.031A8.036,8.036,0,0,0,144.131,136Zm0,13.962a5.932,5.932,0,1,1,5.932-5.932A5.935,5.935,0,0,1,144.131,149.963Z" transform="translate(-125.52 -125.428)" fill="#707070"/>
                </g>
              </g>
            </svg>
          </div>
          <div class="media--action">
              <img 
              src="../../assets/images/icons/training-item-remove.svg"
              @click="removeItem(topic, index)"
              >
          </div>
        </div>
    </div>
</template>

<script>
import AudioRecord from './AudioRecord'
import Embed  from "./Embed.vue";
import ImageEditor from './trainings/ImageEditor.vue'
import axios from 'axios'
import ImageViewer from '@/components/layout/trainings/training_components/ImageViewer.vue';
import GifViewer from '@/components/layout/GifViewer.vue';
import VideoPlayer from '@/components/layout/players/VideoPlayer.vue';
import NewImageEditor from '@/components/layout/trainings/training_components/ImageEditor/NewImageEditor.vue';
import QrcodeVue from 'qrcode.vue'
import VideoTest from './trainings/training_components/VideoTest.vue';
import ScormPlayer from '@/components/layout/scorm/ScormPlayer.vue';
import GlobalModal from './modals/GlobalModal.vue';
import AssignPlusSvg from '@/assets/images/icons/assign-plus.svg?inline';
import VideoTimeArrowSvg from '@/assets/images/icons/training-edit/video_time_arrow.svg?inline'
import VideoRangeSlider from './trainings/training_components/VideoRangeSlider.vue';
import ItemUploadOptions from './trainings/training_components/trainingItem/ItemUploadOptions.vue';
import GallerySide from "@/components/layout/modals/GallerySide.vue";

export default {
    name: 'TrainingItem',
    components:{
      AudioRecord,
      Embed,
      ImageEditor,
      QrcodeVue,
      ImageViewer,
      GallerySide,
      GifViewer,
      VideoPlayer,
      ScormPlayer,
      NewImageEditor,
      VideoTest,
      GlobalModal,
      AssignPlusSvg,
      VideoTimeArrowSvg,
      VideoRangeSlider,
      ItemUploadOptions
  },
    data(){
        return{
            objTestOptions:{
              passed_from: 80,
              retake_test: 1,
              test_shown_duration: 10,
              partially_correct: true,
              show_answers: true,
              show_results: false,
              unlimited_retakes: true,
            },
            updateKey: true,
            startTime:{
              h: 0,
              m: 0,
              s: 0,
            },
            endTime:{
              h: 0,
              m: 0,
              s: 0,
            },
            currentMediaTab: 0,
            item: '',
            topic: '',
            index: '',
            isVideoTestOpen: false,
            isResultsModalOpen: false,
            intScoredPercentage:0,
            videoDuration: 0,
            currentQuestion: 0,
            currentVideoTests: [],
            currentVideoTestStack:[],
            playingVideoTest: {},
            videoPlay: '',
            rerenderingKey: false,
            isDeleteModalOpened: false,
            intAnsweredQuestionsCount: 0,
            updateVideoStartTime: false,
            updateVideoEndTime:false,
            allowSeek: this.trainingItem.allow_seek,
            allowContinue: this.trainingItem.allow_continue,
            oEmbed: [
                {name: 'Twitter', 'shortlink': 'twitter.com', 'url': 'https://publish.twitter.com/oembed?url='},
                {name: 'Facebook', 'shortlink': 'facebook.com', 'url': 'https://www.facebook.com/plugins/post.php?href='},
                {name: 'Facebook', 'shortlink': 'watch.com', 'url': ''},
                {name: 'TikTok', 'shortlink': 'tiktok.com', 'url': 'https://www.tiktok.com/oembed?url='},
                {name: 'SoundCloud', 'shortlink': 'soundcloud.com', 'url': 'https://soundcloud.com/oembed?format=json&url='},
                {name: 'Reddit', 'shortlink': 'reddit.com', 'url': 'https://www.reddit.com/oembed?url='},
                {name: 'Reddit', 'shortlink': 'redditmedia.com', 'url': ''},
                {name: 'Google', 'shortlink': 'google.com', 'url': ''},
                {name: 'WordWall', 'shortlink': 'wordwall.net', 'url': ''},
                {name: 'Instagram', 'shortlink': 'instagram.com', 'url': 'https://graph.facebook.com/v10.0/instagram_oembed?url='},
                {name: 'Pinterest', 'shortlink': 'pinterest.com', 'url': ''},
                {name: 'GeoPortal', 'shortlink': 'geoportal.lt', 'url': ''},
                {name: 'Maps', 'shortlink': 'maps.lt', 'url': ''},
                {name: 'Youtube', 'shortlink': 'youtube.com', url: 'https://youtube.com/oembed?url='},
                {name: 'Youtube', 'shortlink': 'youtu.be', url: 'https://youtube.com/oembed?url='},
                {name: 'Vimeo', shortlink: 'vimeo.com', url: 'https://vimeo.com/api/oembed.json?url='},
                {name: 'Sharepoint', shortlink: 'sharepoint.com', url: ''},
                {name: 'Ted', shortlink: 'ted.com', url: ''},
                {name: 'Spotify', shortlink: 'spotify.com', url: ''},
                {name: 'Deezer', shortlink: 'deezer.com', url: ''},
                {name: 'LRT', shortlink: 'lrt.lt', url: ''},
                {name: 'Giphy', shortlink: 'giphy.com', url: ''},
                {name: 'Loom', shortlink: 'loom.com', url: ''},
                {name: 'Prezi', shortlink: 'prezi.com', url: 'https://prezi.com/p/embed/'},

                // {name: 'Youtube', 'shortlink': 'youtu.be', url: 'https://youtube.com/oembed?url='}

            ],
            audioRecordModal: [-1, -1],
            mobileUploadModal: [-1, -1],
            recorder: '',
            itemType: [
                {type: 'url', title: this.toLocal('training_edit.block.internet'), download:  true},
                {type: 'video', title: this.toLocal('training_edit.block.media'), download:  true},
                {type: 'img', title: this.toLocal('training_edit.image'), download:  true},
                {type: 'doc', title: this.toLocal('training_edit.doc'), download:  true},
            ],
            selectedItemType: -1,
            isEditing: false,
            readOnlyImgCroppa: '',
            fullscreen: null,
            isLazyLoading: true,
            metadataLoaded:false,
            isVideoChangeModalOpened: false,
            tempEvent: '',
            tempTopic: '',
            tempIndex: '',
            isMediaChangeModalOpened: false,
            isDraggingOver:false,
            dragImage: null,
            galleryOpen: false,
            isDeleteItemModalOpened: false,
            deleteItemModalData: {
                
            }
        }
    },
    props: ['trainingItem','videoTests', 'videoTestSettings', 'topic_index', 'item_index', 'readOnly', 'trainingType', 'training', 'videoSubtitles'],
    watch:{
      "$store.state.currentVtest"(){
        this.changeQuestion(this.$store.state.currentVtest);
      },
      selectedItemType(){
        this.$forceUpdate();
      },
      videoTests(){
        if(this.videoTests != undefined){
          this.videoTests.forEach((test)=>{
            if(test.video_id == this.item.id){
              if(test.answers)
                test.answers = JSON.parse(test.answers);
              this.currentVideoTests.push(test);
              if(!this.readOnly){
                this.isVideoTestOpen = true;
              }
            } 
          })
        }
      },
      isEditing(){
        if(this.isEditing == false && this.videoTests && this.videoTests[0] != undefined && this.checkFileType(this.item.content) == 'video'){
          axios.post(`${this.$store.state.api_link}/save-vtest-settings`, {
                    training_id:this.videoTests[0].training_id,
                    video_id: this.item.id,
                    settings: this.objTestOptions,
                }, this.$store.getters.axiosConfig())
        }
        this.updateKey = !this.updateKey
      },
      trainingItem(){
        this.item = this.trainingItem;
        this.topic = this.topic_index;
        this.index = this.item_index;
        this.selectedItemType = this.itemType.findIndex((e)=>e.type == this.trainingItem.type);
      },
      'trainingItem.metadata'(){
        if(this.trainingItem){
          if(this.trainingItem.metadata == undefined || this.trainingItem.metadata[0] == {}) this.isEditing = true; 
        }
      },
      metadataLoaded(){
        if(this.metadataLoaded){
          if(this.trainingItem.type == 'img' && this.trainingItem.half && this.isLeftHalf(this.topic_index, this.item_index)){
            if(this.$refs.imageEditor != undefined ){
              let obj = {
                canvasHeight: this.$refs.imageEditor.canvasHeight,
                startX: this.$refs.imageEditor.imgCroppa.imgData.startX,
                startY: this.$refs.imageEditor.imgCroppa.imgData.startY,
              }
              this.$root.$emit('imgHeightChange', obj, this.topic_index, this.item_index);
            }
          }
        }
      },
      'getNextSibling'(newVal){
         if(this.metadataLoaded){
          if(this.trainingItem.type == 'img' && this.trainingItem.half && this.isLeftHalf(this.topic_index, this.item_index)){
            if(this.$refs.imageEditor != undefined ){
              let obj = {
                canvasHeight: this.$refs.imageEditor.canvasHeight,
                startX: this.$refs.imageEditor.imgCroppa.imgData.startX,
                startY: this.$refs.imageEditor.imgCroppa.imgData.startY,
              }
              setTimeout(() => {
                this.$root.$emit('imgHeightChange', obj, this.topic_index, this.item_index);

              },300)
            }
          }
        }
      }
    },
     computed:{
      getMetadata(){
          return this.item.metadata;
      },
      getMetadataString(){
          return this.item.metadata ? this.item.metadata.data : '';
      },
      getNextSibling(){
        if(this.training)
          return this.training.content[this.topic_index].items[this.item_index+1]
        else return {};
      }
    },
    mounted(){
        this.item = this.trainingItem;
        this.topic = this.topic_index;
        this.index = this.item_index;
        this.selectedItemType = this.itemType.findIndex((e)=>e.type == this.trainingItem.type);
        if(this.trainingItem.newItem){
          this.isEditing = true;
          this.trainingItem.newItem = false;
        }
        if(this.videoTests != undefined){
          this.videoTests.forEach((test)=>{
            if(test.video_id == this.item.id){
              if(!Array.isArray(test.answers))
                test.answers = JSON.parse(test.answers);
              this.currentVideoTests.push(test);
              if(!this.readOnly){
                this.isVideoTestOpen = true;
              }
            } 
          })
          if(this.videoTestSettings != undefined){
            this.videoTestSettings.forEach((setting)=>{
              if(setting.video_id == this.item.id){
                this.objTestOptions = setting;
              }
            })
          }
        }
        //Jeigu training iteme issaugoti laikai, ideti i text boxus
        if(this.trainingItem.start_time){
          this.countVideoTime(this.trainingItem.start_time, this.startTime);
        }
        if(this.trainingItem.end_time){
          this.countVideoTime(this.trainingItem.end_time, this.endTime);
        }
        this.allowSeek = this.trainingItem.allow_seek != undefined ? this.trainingItem.allow_seek : true;
        this.allowContinue = this.trainingItem.allow_continue != undefined ? this.trainingItem.allow_continue : true;
      this.$root.$on('imgHeightChange', (obj, topic_index, item_index)=>{
        if(this.$refs.imageEditor && this.item.half && topic_index == this.topic_index && (item_index == this.item_index-1 || item_index == this.item_index+1)){
          this.$set(this.$refs.imageEditor,'canvasHeight', obj.canvasHeight);
          this.item.metadata= {data: JSON.stringify(this.$refs.imageEditor.imgCroppa.getMetadata()), height: obj.canvasHeight}
          this.$set(this.$refs.imageEditor.imgCroppa.imgData,'startX', obj.startX);
          this.$set(this.$refs.imageEditor.imgCroppa.imgData,'startY', obj.startY);
          // this.$forceUpdate();
        }
      })
      this.$root.$on('rotateHalfImage', (topic_index, item_index)=>{
        if(this.$refs.imageEditor && this.item.half && topic_index == this.topic_index && (item_index == this.item_index-1 || item_index == this.item_index+1)){
          this.$refs.imageEditor.imgCroppa.rotate();
        }
      })
      this.$root.$on('scaleItem', (obj, topic_index, item_index)=>{
        if(this.$refs.imageEditor && this.item.half && topic_index == this.topic_index && (item_index == this.item_index-1 || item_index == this.item_index+1)){
          this.$refs.imageEditor.imgCroppa.scaleRatio = obj.scale;
          this.$refs.imageEditor.imgCroppa.imgData.startX = obj.startX;
          this.$refs.imageEditor.imgCroppa.imgData.startY = obj.startY;
        }
      })
      this.dragImage = new Image();
      this.dragImage.src = require('@/assets/images/icons/dragdrop.svg');
    },
    methods:{
      closeEditing(){
        this.$emit('editingModeCLosed');
      },
      openGallery(){
        this.galleryOpen = true;

      },
      setEndInput(e) {
        this.updateVideoEndTime = !this.updateVideoEndTime
      },
      galleryItemSelect(item){
      
        this.loadContent({target:{value:item}})
        this.galleryOpen = false;
      },
      uploadSubFile(e, topic, index){
        if(!e.target.value.endsWith('.srt') && !e.target.value.endsWith('.vtt')) {
          e.target.value = '';
          return;
        }
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append('topic', topic);
        formData.append('index', index);
        formData.append('training', this.$store.state.currentTraining);
        formData.append('original_name', e.target.files[0].name)
        formData.append('size', e.target.files[0].size);
        formData.append('display_name', e.target.files[0].name.split('.')[0]);
        axios.post(`${this.$store.state.api_link}/upload/subtitle`, 
            formData
        , this.$store.getters.axiosConfigMultipart()).then((response)=>{
            this.loadSubtitleTrack(response.data.file, JSON.parse(response.data.assignData));
        })
      },
      loadSubtitleTrack(file, data){
        if(this.videoPlay.remoteTextTrackEls().length >1){
          this.videoPlay.removeRemoteTextTrack(0)
        }
        this.videoPlay.addRemoteTextTrack({src: this.getTrainingFileURL(file), mode: this.videoPlay.remoteTextTrackEls().length >1 ? 'default' : 'showing', kind: 'captions', label:data.display_name, language:data.display_name}, false);
      },
      uploadSubtitles(){
        this.$refs.subUploadBtn.click();
      },


      insertTime(place) {
        if(place == 'front'){
          if(this.videoPlay.currentTime() >= parseInt(this.endTime.h *60*60)+parseInt(this.endTime.m*60)+parseInt(this.endTime.s)) return;
          this.countVideoTime(this.videoPlay.currentTime(), this.startTime, 'start_time')
          //updatina <VideoRangeSlider esancius sliderius
          this.updateVideoStartTime = !this.updateVideoStartTime;
        }else{
          if(this.videoPlay.currentTime() <= parseInt(this.startTime.h *60*60)+parseInt(this.startTime.m*60)+parseInt(this.startTime.s)) return;
          this.countVideoTime(this.videoPlay.currentTime(), this.endTime, 'end_time');
          //updatina <VideoRangeSlider esancius sliderius
          this.updateVideoEndTime = !this.updateVideoEndTime;
        }
      },
      countVideoTime(value, objTime, key = null){
                let s, m, h = 0;
                s = parseInt(value);
                if(s >= 0 && !isNaN(s)){
                  m = Math.floor(s/60);
                }
                if(m >= 1 && !isNaN(m)){
                  s -= m*60;
                  h = Math.floor(m/60);
                  if(h >= 1 && !isNaN(h)){
                      m -= h*60;
                  }
                }
                if(s >= 0 && !isNaN(s)){
                  objTime.s = Math.round(s);
                } 
                if(m >= 0 && !isNaN(m)){
                  objTime.m = Math.round(m);
                }
                if(h >= 0 && !isNaN(h)){
                  objTime.h = Math.round(h);
                }
                //jeigu yra raktas kuriuo saugoti, issaugo ant trainingItem
                if(key != null && !isNaN(value)){
                  this.$set(this.trainingItem, key, value);
                }
      },

      changeSetting(setting, value){
        switch (setting){
          case 'seek':
              this.allowSeek = value;
              this.$set(this.trainingItem, 'allow_seek', value);
              break;
          case 'continue':
              this.allowContinue = value;
              this.$set(this.trainingItem, 'allow_continue', value);
              break;
          default:
            break;
        }
      },
        changeQuestion(num){
          if(this.isVideoTestOpen == false){
            this.isVideoTestOpen = true;
          }
          if(num == -1) return;
          if(this.currentVideoTests[num] !=undefined){
            this.currentQuestion = num;
            if(!this.readOnly){
            this.$store.state.currentVtest = this.currentQuestion;
            }
          }
        },
        setMediaTab(tab){
          if (tab == 1 && (this.checkFileType(this.item.content) == 'video' || this.checkFileType(this.item.content) == 'yt')) {
            
            this.videoPlay = this.$refs.videoLazy ? this.$refs.videoLazy.player : this.$refs.videoLazyYoutube.player;
            this.$store.state.stopDrag = true;
          }else{
            this.$store.state.stopDrag = false;
          }
          this.currentMediaTab = tab;
        },
        deleteTestModal(){
          this.isDeleteModalOpened = true;
        },
        deleteWholeTest(){
          this.isDeleteModalOpened = false;
          axios.post(`${this.$store.state.api_link}/delete-all-vtest`, {
            training_id: this.$store.state.currentTraining,
            video_id:this.item.id,
          }, this.$store.getters.axiosConfig()).then(()=>{
            this.currentVideoTests = [];
            this.isVideoTestOpen = false;
            this.rerenderingKey;

          })
        },
        deleteQuestion(id){
          let index = this.currentVideoTests.findIndex((e)=>e.id == id);
          if(index != -1){
            let deletableQuestion = this.currentVideoTests[index];
            if(deletableQuestion.id != undefined){
              axios.post(`${this.$store.state.api_link}/delete-vtest`, {
                  question_id: deletableQuestion.id,
                  training_id: this.$store.state.currentTraining,
                  video_id:this.item.id,
              }, this.$store.getters.axiosConfig()).then(()=>{
                this.currentVideoTests.splice(index, 1);
                // let v_index = this.videoTests.findIndex((e)=>e.id == id);
                // if(v_index != -1){
                //   this.videoTests.splice(v_index, 1);
                // }
                this.rerenderingKey = !this.rerenderingKey;
                if(this.currentVideoTests.length <= 0){
                  this.isVideoTestOpen = false;
                  this.currentVideoTests = [];
                }

              })
            }
          }
          if(this.currentQuestion == index){
            if(this.currentVideoTests[this.currentQuestion-1] != undefined){
              this.currentQuestion -=1
            }else if(this.currentVideoTests[this.currentQuestion+1] != undefined){
              this.currentQuestion += 1
            }else{
              this.isVideoTestOpen = false;
              this.currentVideoTests = [];
            }
          }
        },
        addNewQuestion(){
          let video_time = this.videoPlay.currentTime() ? this.videoPlay.currentTime() : 0;
          axios.post(`${this.$store.state.api_link}/new-vtest`, {
              training_id: this.$store.state.currentTraining,
              video_id:this.item.id,
              video_time: video_time,
              question:this.toLocal('generic.question'),
              answers:[{text:this.toLocal('training_edit.answer_yes'), correct: true},{text:this.toLocal('training_edit.answer_no'), correct: false}],
          }, this.$store.getters.axiosConfig())
          .then((response)=>{
            if(response.data.test){
              let test = response.data.test;
              test.answers = JSON.parse(response.data.test.answers);
              this.currentVideoTests.push(test);
              this.currentQuestion = this.currentVideoTests.length-1;
              // this.videoTests.push(test);
            }
          })
          // this.currentVideoTests.push({
          //   answers: [{text:"Taip", correct: true},{text:"Ne", correct: false}],
          //   question: "Question",
          //   training_id: this.$store.state.currentTraining,
          //   video_id: this.item.id,
          //   video_time: Math.floor(this.videoPlay.currentTime),
          // })
        },
        continueVideo(was_answer_correct){
          if(this.currentVideoTestStack.length > 1){
            this.videoPlay.pause();
            this.playVideoTest(this.currentVideoTestStack[1]);
          }
          else{
            this.videoPlay.play();
            this.isVideoTestOpen = false;
            this.playingVideoTest = {};
          }
          if(this.currentVideoTestStack.length > 0){
            this.currentVideoTestStack.shift()
          }
          this.intAnsweredQuestionsCount += was_answer_correct;
        },
        playVideoTest(test){
          this.isVideoTestOpen = true;
          this.playingVideoTest = test;
        },

        videoEnded(){
          this.intScoredPercentage = (this.intAnsweredQuestionsCount/this.currentVideoTests.length).toFixed(2) * 100;
          if(this.currentVideoTests.length >= 1 && this.objTestOptions.show_results){
            this.isResultsModalOpen = true;
          }
          this.$emit('videoEnded');
        },
        getDuration(e){
          this.$nextTick(()=>{
            this.videoPlay = this.$refs.videoLazy ? this.$refs.videoLazy.player : this.$refs.videoLazyYoutube.player;
            if(this.videoSubtitles != undefined && this.checkFileType(this.item.content) == 'video'){
              this.videoSubtitles.forEach((subtitle, index)=>{
                let data = JSON.parse(subtitle.assign_data)
                  if(this.topic == data.topic && this.index == data.index){
                    this.videoPlay.addRemoteTextTrack({src: this.getTrainingFileURL(subtitle.filename), mode: 'default', kind: 'captions', label:data.display_name, language:data.display_name}, false);
                  }
              })
            }
            if (!this.trainingItem.end_time) {
              this.countVideoTime(this.videoPlay.duration(), this.endTime);
            }
            if(this.readOnly && this.currentVideoTests){
              this.videoPlay.on('timeupdate', () => {
                let currentTime = this.videoPlay.currentTime();
                if(this.trainingItem.start_time != undefined){
                  currentTime = parseInt(this.videoPlay.currentTime()) + parseInt(this.trainingItem.start_time);
                }
                  let testFound = this.currentVideoTests.find(i => (i.video_time == Math.floor(currentTime)) && !i.is_triggered)
                  if(testFound && !testFound.is_triggered){
                    if(this.currentVideoTestStack.length < 1){
                      this.currentVideoTestStack.push(testFound);
                      this.videoPlay.pause();
                      this.playVideoTest(testFound);
                      testFound.is_triggered = true;
                    }
                    else{
                      this.currentVideoTestStack.push(testFound);
                      testFound.is_triggered = true;
                    }
                  }
              })
            }
            this.videoPlay.on('ended', ()=> {
                  this.videoEnded();
              });

          })

        },
        toggleVideoTest(){
          this.videoDuration = this.$refs.videoLazy ? this.$refs.videoLazy.player.duration() : this.$refs.videoLazyYoutube.player.duration();
          this.isVideoTestOpen = !this.isVideoTestOpen;
          if(this.currentVideoTests.length <= 0){
            this.addNewQuestion();
          }
        },
        editWritingItem(topic, index){
            this.$emit('editItemTitle', topic, index);
        },
        cancelMediaChange(){
          this.tempEvent = '';
          this.tempTopic = '';
          this.tempIndex = '';
          this.isVideoChangeModalOpened = false;
          this.isMediaChangeModalOpened = false;
        },
        continueMediaChange(deleteTest = false){
          this.onTrainingMediaChange(this.tempEvent, this.tempTopic, this.tempIndex);
          this.isVideoChangeModalOpened = false;
          this.isMediaChangeModalOpened = false;
          if(deleteTest){
            this.deleteWholeTest();
          }
        },
        onTrainingMediaChange(event,topic, index){
            if(this.currentVideoTests.length != 0 && this.tempEvent == ''){
              if(event.target.value.match(/\.(?:mp4|mpg|avi|webm|3gp|mov)$/igm)){
                this.tempEvent = event;
                this.tempTopic = topic;
                this.tempIndex = index;
                this.isVideoChangeModalOpened = true;
              }else{
                this.tempEvent = event;
                this.tempTopic = topic;
                this.tempIndex = index;
                this.isMediaChangeModalOpened = true;
              }
            }else{
              if(this.isDraggingOver) this.isDraggingOver = false;
              this.$emit('onMediaChange', event, topic, index);
              this.tempEvent = '';
              this.tempTopic = '';
              this.tempIndex = ''
            }
        },
        openVideoGallery(topic, index){
            this.$emit('videoGallery', topic, index);
        },
        openImageGallery(topic, index){
            this.$emit('imageGallery', topic, index);
      },
      
        removeItem(topic, index){
          if(this.checkFileType(this.item.content) == 'video'){
              if(this.currentVideoTests.length !=0){
                axios.post(`${this.$store.state.api_link}/delete-all-vtest`, {
                  training_id: this.$store.state.currentTraining,
                  video_id: this.item.id,
                }, this.$store.getters.axiosConfig()).then(()=>{
                  this.currentVideoTests = [];
                  this.isVideoTestOpen = false;
                  this.rerenderingKey;
                })
              }
          };
          this.$emit('itemRemove', topic, index);
        },
        toggleDrag(toggle){
            this.$emit('toggleDrag', toggle);
        },
        checkFileType(file_url){
          if(!file_url) return false;
          let url = file_url.split("§")[0];
          if(url.match(/\.(?:wav|mp3|webm|m4a|aac|3gp|webm|amr|oga|mpga|ogg)$/i)) return 'audio';
          else if(url.match(/\w+\.(?:mp4|mpg|avi|webm|3gp|mov)$/igm)) return 'video';
          else if(url.match(/\w+\.(?:pdf|pptx|xlsx|docx|ppt|xls|doc|odp|odt|ods)$/igm)) return 'doc';
          else if(url.match(/\w+\.(?:png|jpg|jpeg|webp|bmp|heic)$/igm)) return 'img';
          else if(url.match(/\.gif(\?.*)?$/)) return 'gif';
          else if(url.match(/\.(?:youtube|youtu|you)|(?:youtu\.be)$/igm)) return 'yt';
          else return false;
        },
        isNativeVideo(item) {
            return !item.content.startsWith("iframe");
        },
        getPreviewDocumentUrl(content) {
            let url = content.split("§")[0];
            url = this.getTrainingFileURL(url);
            if(!url.endsWith("pdf"))
                // url = "https://docs.google.com/gview?url=" + url + "?time=" + Math.floor(Math.random() * 100000) + "&embedded=true&time=" + Math.floor(Math.random() * 100000);
                url = "https://view.officeapps.live.com/op/embed.aspx?src=" + url;
            else if(this.isMobileWindow()){
                url = "https://docs.google.com/viewer?url="+ url +"&embedded=true";
            }
            return url;
        },
      getTrainingFileURL(url) {
          let protocol = this.$store.state.ssl ? 'https://' : 'http://';
          if (window.isNative && !url.endsWith("pdf") && !url.startsWith("http")) {
            if (this.$store.state.existingDeviceFiles.includes(url)) {
              // window.ReactNativeWebView.postMessage("fetchingFile1:" + '/uploads/'+url);
              return '/uploads/' + url;
            }
            else if (url && !this.$store.state.searchedFilesInDevice.includes(url)) {
              window.ReactNativeWebView.postMessage("checkIfFileExists:" + url);
              if (!this.$store.state.searchedFilesInDevice.includes(url)) this.$store.state.searchedFilesInDevice.push(url);
              return '';
            }
            else if (this.$store.state.nonExistingDeviceFiles.includes(url)) {
              window.ReactNativeWebView.postMessage("NON EXISTING:" + this.getFileUrl(url));
              return this.getFileUrl(url)+'?not-on-device=true';
            }
            return this.getFileUrl(url)
            
          }
          if(this.$store.state.currentTrainingRented){
            return protocol +  process.env.VUE_APP_PARENT_LMS_API + '/uploads/' + url;
          }
          else{
            return this.getFileUrl(url)
          }
            
        },
        generateQRCode(topicIndex, itemIndex){
            axios.post(`${this.$store.state.api_link}/training/generate-qr`,
                {training: this.$store.state.currentTraining, type: this.trainingType, topicIndex: topicIndex, itemIndex: itemIndex, api_key: this.$store.state.lms_key},
                this.$store.getters.axiosConfig()
                ).then((res)=>{
                    if(res.data.status == 'success'){
                      this.$set(this.item, 'QRLink',res.data.url );
                        // this.$forceUpdate();
                    }
                })
                .catch((err)=>{

                });
        },
        loadContent(e){
            var url = e.target ? e.target.value : e.value;
            var embed_url;
            var blockquote_regex = /<blockquote.*?<\/blockquote>/
            var frame_regex = /<\s*iframe[^>]*src=("|')(.*?)("|')[^>]*\/*>/gi;
            var src_regex = /src=['|"][^'|"]*?['|"]/;
            var url_regex = /((\w+:\/\/)[-a-zA-Z0-9:@;?&=\/%\+\.\*!\(\),\$_\{\}\^~\[\]`#|]+)/g;
            var script_regex = /<(\/)?script(.*?)?>/gis;
            var height_regex = /height=["\'](.*?)["\']/;
            var width_regex = /width=["\'](.*?)["\']/;
            // var frame = url.match(frame_regex);
            if(url != this.item.content){
              if(this.item.content.includes(this.$store.state.api_uploads_link))
                this.delete.item(this.item.content);
              if(this.item.metadata) this.item.metadata = [];
            }
            this.item.embed_options = {};
            if(this.item.button){
                if(url.match(frame_regex) == null && url.match(blockquote_regex) == null && url.match(url_regex) != null){
                    this.item.content = url;
                    this.item.url = url;
                    return;
                }
                else{
                    this.$store.state.infoMessage.setMessage('error', this.toLocal('error.wrong_url'));
                    return;
                }
            }
            else{

                if(e.target.value == ''){
                  this.item.content ='';
                  this.item.url ='';
                  this.item.script ='';
                  this.item.contentType = '';
                    return;
                }
                if(url.match(frame_regex) != null || url.match(blockquote_regex) != null){
                        var url_allowed = false;
                        this.oEmbed.forEach((el)=>{
                            if(url.indexOf(el.shortlink) >= 0) {
                            url_allowed = true;
                            }
                        });
                        if(!url_allowed){
                            this.$store.state.infoMessage.setMessage('error', this.toLocal('training_item.link_not_allowed'));
                            return;
                        }
                        if(url.match(frame_regex) != null){
                            var frame =url.match(frame_regex)[0];

                            var height = url.match(height_regex) ? url.match(height_regex)[1] : false;
                            var width = url.match(width_regex) ? url.match(width_regex)[1] : false;
                            if(this.item.embed_options == undefined) this.item.embed_options = {};
                            if(height) this.item.embed_options.height = height;
                            if(width) this.item.embed_options.width = width;
                            var src = frame.match(src_regex) ? frame.match(src_regex)[0] : '';
                            this.item.contentType = 'frame'
                            this.item.url = src.match(url_regex) ? src.match(url_regex)[0] : '';
                            this.item.content = src.match(url_regex) ? src.match(url_regex)[0] : '';
                            return;
                        }
                        if(url.match(blockquote_regex) != null){
                           
                            this.item.contentType = 'blockquote';
                            this.item.content = url.match(blockquote_regex)[0];
                            this.item.url = '';
                            this.item.script = (url.match(script_regex)[0]).match(url_regex)[0];
                            return;
                        }    
                }
                else{
                    this.oEmbed.forEach((el)=>{
                    if(url.indexOf(el.shortlink) >= 0) {
                        embed_url = el;
                    }
                    });
                    if(url.includes('prezi')){
                      if(!url.includes('/p/embed')){
                        let splitUrl = url.split('/');
                        let foundResult = '';
                        splitUrl.forEach((split, index)=>{
                          if(split.includes('prezi.com')){
                            foundResult = index+1;
                          }
                        })
                        if(foundResult != ''){
                          let newUrl = 'https://prezi.com/p/embed/' + splitUrl[foundResult] + '/';
                          url = newUrl;
                          this.item.contentType = 'frame'
                          this.$set(this.item, 'content', url);
                          this.item.url = url;
                          return;
                        }
                      }else{
                        this.item.contentType = 'frame'
                        this.$set(this.item, 'content', url);
                        this.item.url = url;
                        return;
                      }
                    }
                    if(embed_url != undefined && embed_url.url !=''){
                        this.item.contentType = 'blockquote';
                        axios.post(`${this.$store.state.api_link}/embed/link`,
                        {link: embed_url.url+url},
                            this.$store.getters.axiosConfig()
                        ).then((res)=>{
                            var html = res.data.html;
                            if(html.match(frame_regex) != null){
                                var frame = html.match(frame_regex)[0];
                                var src = frame.match(src_regex)[0];
                                this.item.contentType = 'frame'
                                this.item.url = src.match(url_regex)[0];
                                this.item.content =src.match(url_regex)[0];
                                return;
                            }
                            else{
                                var script = html.match(script_regex)[0];
                                var script_url = script.match(url_regex)[0];
                                var content = html.replace(script_regex, '');
                                this.item.content = content;
                                this.item.url = url;
                                this.item.script = script_url;
                            }
                        }).catch((err)=>{
                            this.item.content ='';
                            this.item.url ='';
                            this.item.script ='';
                            this.item.contentType = '';
                            this.$store.state.infoMessage.setMessage('error', this.toLocal('error.unable_to_embed'));
                            return;

                        });
                    }
                    else{
                        url = url.replace("youtu.be","youtube.com/embed");
                        this.item.contentType = 'frame'
                        this.$set(this.item, 'content', url);
                        if(this.checkFileType(this.item.content) == 'img')
                          this.isEditing=true;
                        this.item.url = url;
                        return;
                    }
                }
            }
        },
        deleteItem(link){
          axios.post(`${this.$store.state.api_link}/training/delete-item`,
            {link: link.split('§')[0]},
            this.$store.getters.axiosConfig()
          ).then((res)=>{

          })
          .catch((err)=>{

          })
        },
        editingMode(e){
          if(e.target.closest(".gallery--side") || e.target.closest('.add-test-btn') || e.target.closest('.delete') || e.target.closest('.new-question-btn')){
            return;
          }
          if(!this.readOnly && !this.trainingItem.half){
            this.isEditing = false;
            if(this.$refs[`trainingURLInput-${this.topic}-${this.index}`]){
              this.$refs[`trainingURLInput-${this.topic}-${this.index}`].blur();
            }
            // this.loadContent(this.$refs[`trainingURLInput-${this.topic}-${this.index}`].blur);
          }
          else if(this.trainingItem.half && !this.readOnly){
            if(e.target.closest(".media--editing") || e.target.closest(".media--content--item")){
              return;
            }
            this.isEditing = false;
            this.closeEditing();

            if(this.$refs[`trainingURLInput-${this.topic}-${this.index}`]){
              this.$refs[`trainingURLInput-${this.topic}-${this.index}`].blur();
            }
          }
        },
        saveMetadata(e, item){
            if(Object.keys(e[0].getMetadata()).length != 0)
              item.metadata= {data: JSON.stringify(e[0].getMetadata()), height: e[1]};
        },
        toggleItemButton(state){
          if(!this.item.title || this.item.title == '') this.item.title=this.toLocal('generic.open_img')
          if(this.item.url == undefined || this.item.url == ''){
            this.item.url = this.item.content;
            
          }
          this.item.button = state;
          this.$forceUpdate()
        },
        toggleFullscreen(item) {
          this.$store.state.overlay_content = item.content
          this.$store.state.overlay_open = !this.$store.state.overlay_open
          if(item.metadata)
            this.$store.state.overlay_metadata = item.metadata
        },
        fullscreenChange (fullscreen) {
          this.fullscreen = fullscreen
        },
        loadedFrame(e){
        },
        getVideoMetadata(e){
        },
        lazyload(e){
          this.isLazyLoading= false;
        },
  
        getEmbedAspectRatio(item){
          if(item.embed_options && item.contentType != 'blockquote'){
            if( item.embed_options.height != undefined && item.embed_options.width != undefined){
              if(item.embed_options.height/item.embed_options.width < 1 && item.embed_options.height/item.embed_options.width > 0.4) return '56.25%';
              else return '';
            }
            else if(item.embed_options && item.embed_options.aspect_ratio)
              return this.checkFileType(item.content) == 'doc' ? item.embed_options.aspect_ratio == 0.56 ? !this.readOnly ? 59.4 + '%' : 59.1 + '%' : item.embed_options.aspect_ratio * 100 + '%' : item.embed_options.aspect_ratio * 100 + '%';
            else if(this.checkFileType(item.content) == 'yt' || this.checkFileType(item.content) == 'video') return '56.25%';
            else{
              if(item.contentType == 'frame') return ['img', 'gif'].includes(this.checkFileType(item.content)) ? '' : this.isMobileWindow() ? '140%' : '56.25%';
              else return item.contentType == 'blockquote' || ['img', 'gif', 'audio'].includes(this.checkFileType(item.content)) ? '' : this.isMobileWindow() ? '140%' : '56.25%'
            }
          }
          else {
            if(item.contentType == 'frame') return this.checkFileType(item.content) == 'img' ? '' : this.isMobileWindow() ? '140%' : '56.25%';
            else return item.contentType == 'blockquote' || ['img', 'gif', 'audio'].includes(this.checkFileType(item.content)) ? '' : this.isMobileWindow() ? '140%' : '56.25%'
          }
        },
        showDoubledSlider(){
          if(this.trainingItem.half && 
          (this.training.content[this.topic_index].items[this.item_index+1] && 
          this.training.content[this.topic_index].items[this.item_index+1].half) &&
          this.isLeftHalf(this.topic_index, this.item_index) && 
          this.checkFileType(this.training.content[this.topic_index].items[this.item_index+1].content) == 'img' &&
          !this.training.content[this.topic_index].items[this.item_index+1].button
          )
            return true;
          else return this.trainingItem.half ? false : undefined;
        },
        showSlider(){
          if(this.trainingItem.half && 
          (this.training.content[this.topic_index].items[this.item_index-1] && 
          this.training.content[this.topic_index].items[this.item_index-1].half) &&
          !this.isLeftHalf(this.topic_index, this.item_index) && 
          this.checkFileType(this.training.content[this.topic_index].items[this.item_index-1].content) == 'img'
          )
            return false;
          else return true;
        },
        getHalfPosition (topicIndex, itemIndex) {
            if(this.trainingItem.half){
                let halves = 0;
                for (let i = 0; i < this.training.content[topicIndex].items.length; i++) {
                if(i == itemIndex){
                    return halves % 2 == 0 ? "left" : "right";
                }
                  const item = this.training.content[topicIndex].items[i];
                  if(item.half){
                      halves++;
                  }
                }
            }
            return false;
        },
        isLeftHalf(topicIndex, itemIndex) {
            return this.getHalfPosition(topicIndex, itemIndex) == "left";
        },

        uploadDragStart(e){
          this.isDraggingOver=true;
        },
        uploadDragOver(e){
          this.isDraggingOver=true;
        },
        uploadDragOverImage(e){
          e.dataTransfer.dropEffect = 'copy'
          e.dataTransfer.setDragImage(this.dragImage, 0, 0)
        },
        isIOS() {
          return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        }

      
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/layout/_trainingItemScoped.scss";
.relative-container{
  &.absolute{
    position: absolute;
  }
}
</style>
<style lang="scss">
.test-info{
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  display: flex;
  justify-content: center;
  &.first{
    margin-right: 20px;
  }
  .circle{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #7D7D7D;
    margin-right: 4px;
    &.yellow{
      background: #F3DE18;
    }
    &.gray{
      background: #FFFFFF;
    }
  }
}
.answer-colors{
  display: flex;
  justify-content: center;
}
.desc-open{
  display: flex;
  justify-content: space-between;
  justify-content: flex-end;
  flex-grow: 1;
  .delete-whole{
    font-weight: 400;
    font-size: 16px;
    text-decoration-line: underline;
    cursor: pointer;
  }
}
.new-question-btn{
  background: #FFFFFF;
border: 1px solid #333333;
border-radius: 30px;
height: 36px;
margin: 16px 0;
padding: 6px 16px;
text-align: start;
display: flex;
align-items: center;
gap: 16px;
font-size: 16px;
line-height: 24px;
color: #333333;
cursor: pointer;
user-select: none;
transition: 0.25s;
&:hover{
  background: #E2E2E2;
}
}

.content--tabs{
  width: 100%;
  background-color:  #EFEFEF;
  padding: 8px 00px;
  border-radius: 8px;
  padding-bottom: 0;
  display: flex;
  .single--tab{
    cursor: pointer;
    max-width: 33%;
    font-size: 14px;
    padding: 6px 40px;
    border-radius: 8px 8px 0px 0px;
    transition: 0.25s;
    background-color:  #EFEFEF;
    color: rgba(51, 51, 51, 0.5);
    flex-grow: 1;
    text-align: center;
    gap: 2px;
    &.active{
      background-color: white;
      cursor: default;
      color: black;
      font-weight: 600;
    }
  }
}
.half--item .content--tabs{
  .single--tab{
    padding: 3px 8px;
  }
}

.video-test-under{
  display: flex;
  position: relative;
  height: 36px;
  .new-question-btn{
    margin: 0;
    position: absolute;
    left: 8px;
  }
  .video-nav{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    .nav{
      background: #EFEFEF;
      border-radius: 20px;
      padding: 5px 15px;
      font-size: 14px;
      cursor: pointer;
      &.inactive{
        opacity: 0.5;
        cursor: default;
      }
    }
    .nav-middle{
      font-size: 14px;
      background: #EFEFEF;
      border-radius: 20px;
      padding: 5px 15px;
    }
  }
}

.video--settings{
  display: flex;
  padding: 24px 12px;
  .left-half{
    width: 60%;
    flex-grow: 0.6;
    display: flex;
    flex-direction: column;
    gap: 48px;
    .setting{
      width: 100%;
      display: flex;
      flex-direction: column;
      .setting-title{
        font-size: 14px;
        font-weight: bold;
      }
    }

  }
  .right-half{
    width: 40%;
    flex-grow: 0.4;
    padding-left: 40px;
    padding-right: 40px;
    border-left: 1.5px solid #E2E2E2;
    display: flex;
    flex-direction: column;
    gap: 40px;
    .setting{
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;
      .setting-title{
        font-size: 14px;
        font-weight: bold;
      }
      .input-box{
        width: 100%;
        gap: 16px;
        display: flex;
        justify-content: center;
        .i-btn{
          display: flex;
          align-items: center;
          width: 40%;
          border-radius: 20px;
          padding: 6px 12px;
          background: #E2E2E2;
          justify-content: center;
          font-size: 16px;
          transition: 0.25s;
          &:hover{
            cursor: pointer;
            background: #F3DE18;
          }
          &.active{
            background: #F3DE18;
            cursor: default;
          }
        }
      }
    }
  }
}

.timestamp-container{
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 6px;
  input{
    width: 12%;
    text-align: center;
    padding: 8px 0;
    border: none;
    border-radius: 6px;
    background: #FFFFFF;
    border-bottom: 2px solid rgba(112, 112, 112, 1);
    box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.14);
    &::-webkit-inner-spin-button, &::-webkit-outer-spin-button{
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  }
  span{
    font-size: 12px;
  }
  .arrow{
    margin-left: 14px;
    border: 1px solid #333333;
    border-radius: 20px;
    background: #FFFFFF;
    padding: 0 14px;
    transition: 0.25s background-color;
    svg{
      stroke: #333333;
      path{
        stroke: #333333;
      }
    }
    &:hover{
      background-color: #F3DE18;
      cursor: pointer;
    }
    &.arrow-left{
      transform: rotate(180deg);
    }
  }
}
.sub_upload_btn{
    display: none;
}
</style>